"use client";

import Link from "next/link";
import React from "react";
import CustomLink from "./custom-link";
import { useRouter } from "next/navigation";

function Breadcrumbs({ crumbs, color, lang }) {
  const router = useRouter();
  const handleButtonClick = () => {
    if (typeof window !== "undefined") {
      const parentURL = window.location.origin;

      if (lang === "en") {
        // Use router.push for client-side navigation to parentURL
        router.push(parentURL);
      } else {
        // Use router.push for client-side navigation to '/hi'
        router.push(`/${lang}`);
      }
    }
  };
  return (
    <nav className="custom-container" aria-label="Breadcrumb">
      <ol className="flex justify-start items-start flex-wrap my-6">
        <li onClick={handleButtonClick} className="cursor-pointer">
          <span
            className={`text-base  uppercase ${
              color ? "text-primaryWhite" : "text-primaryBlack"
            }`}
          >
            Home
          </span>
        </li>

        {crumbs.map((page, index) => (
          <li key={page.name}>
            <div className="flex">
              <svg
                className={`h-5 w-5 flex-shrink-0 ${
                  color ? "text-primaryWhite" : "text-primaryBlack"
                }`}
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
              </svg>
              <CustomLink
                lang={lang}
                href={page.href}
                className={
                  "text-base uppercase font-medium " +
                  (index === crumbs.length - 1
                    ? "text-primaryBlue"
                    : "text-primaryBlack")
                }
                aria-current={page.current ? "page" : undefined}
              >
                {page.name}
              </CustomLink>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
export default Breadcrumbs;
